import React from "react"
import { Flex, Box, Heading, Text } from "@radix-ui/themes"

interface PageHeaderProps {
  title: string
  subtitle?: string
  description?: string
  action?: React.ReactNode
  children?: React.ReactNode
  className?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  description,
  action,
  children,
  className = ""
}) => {
  return (
    <Flex align="center" justify="between" className={className}>
      <Box>
        <Heading size="7" mb="1">
          {title}
        </Heading>
        {(subtitle || description) && (
          <Text size="3" color="gray">
            {subtitle || description}
          </Text>
        )}
      </Box>
      {(action || children) && (
        <Flex align="center" gap="2">
          {action}
          {children}
        </Flex>
      )}
    </Flex>
  )
}

export default PageHeader 